import { KnowFormat } from 'interfaces/Know'
import { KnowRejectionReason } from 'interfaces/KnowRejectionReasons'

export const filterRejectionReasonsByVialionLevel = (reasons: KnowRejectionReason[], violationLevel: 'QUALITY' | 'SAFETY') =>
    reasons.filter((reason) => reason.violationLevel.toString().startsWith(violationLevel))

export const filterRejectionReasonsByKnowFormat = (reasons: KnowRejectionReason[], knowFormat: KnowFormat) =>
    reasons.filter((reason) => reason.supportedKnowTypes.includes(knowFormat))
